import { useQuery } from '@tanstack/react-query';
import {
  getCountries,
  getCountriess,
  getPublicCountries,
  getPeopleProfileCountries,
  PublicCountry,
} from './location';

export const useGetCountries = (options = {}) => {
  const { data, isLoading, refetch } = useQuery({
    queryKey: ['COUNTRIES'],
    queryFn: getCountries,
    ...options,
  });

  return { data, isLoading, refetch };
};
export const useGetCountriess = () => {
  const { data, isPending } = useQuery<
    { label: string; value: string }[],
    Error
  >({
    queryKey: ['ALL_COUNTRIES_LIST'],
    queryFn: async () => getCountriess(),
  });

  return {
    countries: data,
    isPending,
  };
};

// The country list to use before creating an organisation (Google signup and
// normal signup both need this) — served by our own backend rather than a
// third-party API or a static npm package.
export const usePublicCountriesQuery = () => {
  return useQuery<PublicCountry[], Error>({
    queryKey: ['PUBLIC_COUNTRIES'],
    queryFn: getPublicCountries,
    staleTime: 1000 * 60 * 60, // country list changes essentially never
  });
};

// For an authenticated org-context country picker (e.g. Organization
// Settings) — see getPeopleProfileCountries.
export const usePeopleProfileCountriesQuery = () => {
  return useQuery<PublicCountry[], Error>({
    queryKey: ['PEOPLE_PROFILE_COUNTRIES'],
    queryFn: getPeopleProfileCountries,
    staleTime: 1000 * 60 * 60,
  });
};
